import { render } from "./ReturnAndRefundComponent.vue?vue&type=template&id=9746cb04"
import script from "./ReturnAndRefundComponent.vue?vue&type=script&lang=js"
export * from "./ReturnAndRefundComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/returnAndRefunds/ReturnAndRefundComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9746cb04"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9746cb04', __exports__)) {
    api.reload('9746cb04', __exports__)
  }
  
  module.hot.accept("./ReturnAndRefundComponent.vue?vue&type=template&id=9746cb04", () => {
    api.rerender('9746cb04', render)
  })

}


export default __exports__